var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"type-select"},_vm._l((_vm.tabsList),function(tab,ti){return _c('div',{key:ti,class:['item',_vm.curType == tab.value?'active':''],on:{"click":function($event){return _vm.handleSelect(tab)}}},[_vm._v(" "+_vm._s(tab.text)),(tab.count)?_c('span',[_vm._v("("+_vm._s(tab.count)+")")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }